import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MessageService } from "primeng/api";
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import { States } from "src/app/models/address/brazilian-states";
import { CepCityStateValidation } from "src/app/models/address/cep-city-state-validation";
import { ViaCep } from "src/app/models/address/via-cep";
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: 'root'
})
export class AddressService {

	private apiUrl = environment.apiUrl;

	constructor(private httpClient: HttpClient, private messageService: MessageService) {
	}

	getViaCep(zipCode: string): Observable<ViaCep> {
		return this.httpClient.get<Record<string, string | number>>(`${this.apiUrl}/api/v2/address/zip-codes/${zipCode}`)
			.pipe(
				map((response: Record<string, string | number>) => {
					// TODO O mapeamento abaixo deverá ser removido o backend deve retornar a resposta com os atributos em inglês
					// Map the API response to the ViaCep model
					const viaCep: ViaCep = {
						postalCode: response.cep as string,
						street: response.logradouro as string,
						complement: response.complemento as string,
						unit: response.unidade as string,
						district: response.bairro as string,
						city: response.localidade as string,
						stateAbbreviation: response.uf as string,
						state: response.estado as string,
						region: response.regiao as string,
						ibgeCode: String(response.ibge),
						giaCode: String(response.gia),
						areaCode: response.ddd as string,
						siafiCode: String(response.siafi)
					};
					return viaCep;
				})
			);
	}

	getStates(): Observable<States[]> {

		return this.httpClient.get<States[]>(`${this.apiUrl}/api/address/states`)
			.pipe(
				map((response: States[]) => {
					return response;
				})
			);

	}

	getCities(uf: string): Observable<string[]> {

		return this.httpClient.get<string[]>(`${this.apiUrl}/api/address/cities/${uf}`)
			.pipe(
				map((response: string[]) => {
					return response;
				})
			);

	}


	validateCepCityAndState(cepCityStateValidation: CepCityStateValidation): Observable<boolean> {
		return this.httpClient.post<boolean>(`${this.apiUrl}/api/v3/address/zip-codes/validation`, cepCityStateValidation);
	}

}